/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var directives;
    (function (directives) {
        var ManageSection = /** @class */ (function () {
            function ManageSection() {
                this.templateUrl = './app/views/directives/manageForm/manageSection.html';
                this.controller = ['$scope', 'formService', 'deleteService', 'securityMatrixService', '$rootScope', ManageSectionController];
                this.controllerAs = 'controller';
                this.restrict = 'E';
                this.scope = {
                    isConfigureMode: "=",
                    isEditMode: "=",
                    manageSection: "=",
                    process: "=",
                    processConfigurationId: "=",
                    processConfiguration: "=",
                    formDataId: "=",
                    formId: "="
                };
            }
            ManageSection.prototype.link = function ($scope, element, attrs) {
            };
            return ManageSection;
        }());
        directives.ManageSection = ManageSection;
        var ManageSectionController = /** @class */ (function () {
            function ManageSectionController(scope, formService, deleteService, securityMatrixService, $rootScope) {
                var _this = this;
                this.scope = scope;
                this.formService = formService;
                this.deleteService = deleteService;
                this.securityMatrixService = securityMatrixService;
                this.$rootScope = $rootScope;
                scope.save = function () { return _this.save(); };
                scope.editSecurityMatrix = function () { return _this.editSecurityMatrix(); };
                scope.deleteSection = function (ms) { return _this.deleteSection(ms); };
                scope.userActionInitiated = function (u) { return _this.userActionInitiated(u); };
                scope.hideSection =
                    {
                        hideSection: false
                    };
                if (scope.manageSection.manageSectionType === 5 /* EmbeddedForm */) {
                    this.formService.getProcessConfigurationForms(this.scope.processConfigurationId)
                        .then(function (f) {
                        scope.forms = f;
                    });
                }
                this.loadEmbeddedForm();
                this.scope.groupDeleteConfirmation =
                    {
                        show: false
                    };
                this.scope.deleteGroupClicked = function () { return _this.deleteGroupClicked(); };
            }
            ManageSectionController.prototype.deleteGroupClicked = function () {
                this.scope.groupDeleteConfirmation.show = true;
            };
            ManageSectionController.prototype.deleteSection = function (section) {
                this.deleteService.deleteWithModalConfirmIfNecessary("ManageSection", section.id, "Manage Section");
            };
            ManageSectionController.prototype.editSecurityMatrix = function () {
                this.securityMatrixService.openSecurityMatrixModal(this.scope.manageSection.securityMatrix, this.scope.processConfigurationId);
            };
            ManageSectionController.prototype.loadEmbeddedForm = function () {
                var _this = this;
                if (this.scope.manageSection.manageSectionType ===
                    5 /* EmbeddedForm */ &&
                    this.scope.manageSection.embeddedForm != null) {
                    this.formService.getFormConfiguration(this.scope.manageSection.embeddedForm.id)
                        .then(function (f) {
                        _this.scope.manageSection.embeddedForm = f;
                    });
                }
            };
            ManageSectionController.prototype.save = function () {
                this.loadEmbeddedForm();
                this.formService.saveAllChanges();
            };
            ManageSectionController.prototype.userActionInitiated = function (userAction) {
                this.$rootScope.$broadcast('userActionInitated', userAction);
            };
            return ManageSectionController;
        }());
        directives.ManageSectionController = ManageSectionController;
    })(directives = warsApp.directives || (warsApp.directives = {}));
})(warsApp || (warsApp = {}));
warsApp.registerDirective('ManageSection', []);
